import { Typography } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { RotationDirection } from '../SystemSettingsUtils'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { J1ActionbackwardsarrowB, J1ActionforwardarrowB, K1Generic } from '@e3dc-react/icons'

interface RotatingFieldCardProps {
  title: string
  rotationDirection: RotationDirection
}

const useStyles = makeStyles()(theme => ({
  cardContainer: {
    display: 'flex',
    flexDirection: 'row',
    borderRadius: theme.shape.borderRadius,
    justifyContent: 'space-between',
    overflow: 'hidden',
    background: theme.palette.grey.grey07,
    padding: theme.spacing(3),
    border: `1px solid ${theme.palette.shades.shade03}`,
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  iconContainer: {
    display: 'flex',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: 'white',
    justifyItems: 'center',
    alignItems: 'center',
    border: 'solid',
    borderColor: theme.palette.grey.grey06,
    borderWidth: '1px',
    padding: theme.spacing(1),
  },
  icon: {
    color: theme.palette.primary.main,
    fontSize: '35px',
  },
}))

const RotatingFieldCard: React.FC<RotatingFieldCardProps> = ({ title, rotationDirection }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()

  return (
    <div className={classes.cardContainer}>
      <div className={classes.textContainer}>
        <Typography variant={'h3'} marginBottom={1}>
          {title}
        </Typography>
        <Typography variant={'subtitle2'}>
          {rotationDirection === RotationDirection.right
            ? t('systemSettings.solar.right')
            : rotationDirection === RotationDirection.left
            ? t('systemSettings.solar.left')
            : t('common.notActive')}
        </Typography>
      </div>
      <div className={classes.iconContainer}>
        {rotationDirection === 2 ? (
          <J1ActionbackwardsarrowB className={classes.icon} />
        ) : rotationDirection === 1 ? (
          <J1ActionforwardarrowB className={classes.icon} />
        ) : (
          <K1Generic className={classes.icon} />
        )}
      </div>
    </div>
  )
}

export default RotatingFieldCard
